var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-completed_svg__a",
    x1: "80.617%",
    x2: "16.412%",
    y1: "4.423%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E1E1E1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#202E4A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-completed_svg__a)",
    strokeWidth: 2,
    d: "M9.744 5.625h9.431a2.2 2.2 0 012.2 2.2V22.5h0-13.83V7.825a2.2 2.2 0 012.2-2.2z",
    transform: "translate(1.875 1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.65,
    d: "M14.151 13h5.029m-5.029 3.375h5.029"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 1.65,
    d: "M4.075 1.75h9.43a2.2 2.2 0 012.2 2.2v20.3h0-13.83V3.95a2.2 2.2 0 012.2-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 1.65,
    d: "M8.005 18.625h1.57a1.1 1.1 0 011.1 1.1v4.525h0-3.77v-4.525a1.1 1.1 0 011.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.65,
    d: "M6.276 7.375h5.029M6.276 10.75h5.029m-5.029 3.375h5.029"
  }))));
}
export default SvgHotelCompleted;